import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApifirstService } from 'src/app/service/apifirst.service';
import { FdrsClientService } from 'src/app/service/fdrs-client.service';
import { RpcClientService } from 'src/app/service/rpc-client.service';
import * as environmentUrl from 'src/environments/environment';


@Component({
  selector: 'app-repair-procedure',
  templateUrl: './repair-procedure.component.html',
  styleUrls: ['./repair-procedure.component.scss']
})
export class RepairProcedureComponent implements OnInit {
  ptsUrl = environmentUrl.environment.ptsUrl;
  public sessionId: any;
  public temp: any = [];
  public vinNumber: any;
  public gIdArray: any = [];
  public userName: string = '';
  public userType: string = '';
  public language: string = '';
  public country: string = '';
  public UserTypeID: number = 0;
  public countryThree: string = '';
  isEnableService = false;
  ptsEngineServiceResponseObj: any;
  globalServices: any = [];
  globalManagedRes: any;
  FDRSStatusLoader: boolean = false;
  webSocketHandshake: boolean = false;
  fdrsSubscription: Subscription = new Subscription;
  tokenSubscription: Subscription = new Subscription;
  serviceNameListSubscription: Subscription = new Subscription;
  gIdRepairSubscription: Subscription = new Subscription;
  repairSubscription: Subscription = new Subscription;
  viewCompleteRepair: boolean = false;
  constructor(private service: ApifirstService, private router: Router, private modalService: NgbModal,private rpcClient: RpcClientService, private fdrsClient: FdrsClientService) { }

  ngOnInit(): void {
    this.service.setShowWhatsNew(false);
    this.sessionId = localStorage.getItem("sessionID");
    //update page number
    const requ = {
      "sessionId": this.sessionId,
      "pageid": "17"
    }
    this.service.updatePage(requ).subscribe(data => { })

    this.tokenSubscription = this.service.tokenObj.subscribe((data) => {
      let token: any = data;
      this.vinNumber = token.vin;
      this.userName = token.username;
      this.userType = token.userType;
      this.country = token.country;
      this.language = token.language;
      this.countryThree = token.countryThree;
      if (Object.keys(data).length !== 0) {
        if (this.userType == 'FORD_INTERNAL') {
          this.UserTypeID = 1
        } else if (this.userType == 'PTS_DEALER') {
          this.UserTypeID = 3;
        } else if (this.userType == 'PTS_AFTERMARKET') {
          this.UserTypeID = 2;
        }
    }
  })

    this.serviceNameListSubscription = this.service.serviceNameListservice.subscribe((data) => {
      this.globalServices = data;
      for (let obj of this.globalServices) {
        if (obj.serviceName == "PTS Service") {
          this.ptsEngineServiceResponseObj = obj;
        }
      }
    })

    this.gIdRepairSubscription = this.service.storeGidRepair.subscribe((data) => {
      this.gIdArray = data;
    })

    this.repairSubscription = this.service.repairObj.subscribe((data) => {
      this.temp = data;
      console.log('Repair Obj OTX--------', this.temp);
      this.checkAbortStatus(this.temp)
    })

  }

  checkAbortStatus(result: any) {
    for(let obj of result) {
      if(obj.result.state == 'Aborted') {
        let Gid = obj.procRef.procUidRef;
        this.gIdArray = this.gIdArray.filter((value: any) => value !== Gid);
        this.service.storeGidRepair.next(this.gIdArray);
      }
    }
  }

  navigateToRepQua() {
    this.viewCompleteRepair = true;
    this.service.isRepairProcedure.next(true);
    this.service.isPostRepairProcedure.next(false);
    this.service.control.next(true);
    this.service.resumeRVC.next(false);
    this.service.repairPostRepairBtnClick(this.sessionId).subscribe((data) => {
      this.viewCompleteRepair = false;
      console.log('repair post repair btn click:', data);
      this.router.navigate(['/repair']);
    })
  }

  navigateToTest(id: string, kind: string, uidRef: string, title: string, content: any, networkTestStatus: any) {
    //Count test button click to enable or disable Go button in repair qualification page.
    this.service.candidateId.next(id);
    this.service.candidateUidRef.next(uidRef);
    let repairObj = {
      'id': id,
      'screen': 'repair',
      'kind': kind
    }
    this.service.navigatetoPreviousScreen.next(repairObj);
    if (kind == 'OTX-CANDIDATE' || kind == 'OTX-SERVFUNC-CANDIDATE' || kind == 'OTX_DIAGNOSTIC-CANDIDATE') {
      let selectedRecord = [{
        "rating": 5,
        "procedure": title,
        "state": 'Untested'
      }]
      this.service.selectedDiagnosticProcedureData$.next(selectedRecord);
      this.service.navigatePreviousScreen.next('repairProcedure');
      this.getFDRSStatus(networkTestStatus,content,id);
    } else if (kind == 'PINPOINT-CANDIDATE' || kind == 'GENERAL-INFORMATION-CANDIDATE' || kind == 'REPAIR-INFO-CANDIDATE') {
      const req = {
        "sessionId": this.sessionId,
        "pageid": "13"
      }
      this.service.updatePage(req).subscribe(data => { })
      this.router.navigate(['/view']);
    } else if (kind == 'TSB-CANDIDATE') {
      const req = {
        "sessionId": this.sessionId,
        "pageid": "13"
      }
      this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes = data;
        if (!this.globalManagedRes) {
          this.isEnableService = true;
        } else {
          this.isEnableService = false;
        }
        if (this.isEnableService) {
          this.service.updatePage(req).subscribe(data => { })
          var procUidref = id;
          procUidref = procUidref.substring(4);
          procUidref = procUidref.replace("/", "-");
          if (procUidref == "68-2013") {
            procUidref = "068/2013";
          }
          console.log("TSB-procUid", procUidref);
          const path = this.ptsUrl + "Transport?link=001&param=" + procUidref;
          window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
          this.router.navigate(['/view']);
        } else {
          this.service.selectedGlobalServices.next('PTS Service');
          this.router.navigate(['/globalServiceEnabled']);
        }
      })
    } else if (kind == 'ETIS-CANDIDATE') {
      const req = {
        "sessionId": this.sessionId,
        "pageid": "17"
      }
      this.service.getGlobalManagedServicesDetails(this.ptsEngineServiceResponseObj.id).subscribe((data) => {
        this.globalManagedRes = data;
        if (!this.globalManagedRes) {
          this.isEnableService = true;
        } else {
          this.isEnableService = false;
        }
        if (this.isEnableService) {
          this.service.updatePage(req).subscribe(data => { })
          // New Component Implementation Not Known
          const path = this.ptsUrl + "transport/?link=700&params=" + this.vinNumber + "&uid=" + uidRef + "&procuid=" + id;
          window.open(path, '', 'width=1000px,innerHeight=800px,resizable=yes,scrollbars=yes');
          for (let candidate of this.temp) {
            if (candidate.procRef.procUidRef == id) {
              console.log('********', candidate);
              candidate.result.state = 'Viewed';
              break;
            }
          }
          if (!this.gIdArray.includes(id)) {
            this.gIdArray.push(id);
            this.service.storeGidRepair.next(this.gIdArray);
          }
          this.service.repairObj.next(this.temp);
          let req1 = {
            "sessionId": this.sessionId,
            "faultFoundValue": "false",
            "faultComponentGNumber": "",
            "pageState": "REPAIR",
            "vin": this.vinNumber,
            "userId": this.userName,
            "userType": this.userType,
            "languageCode": this.language,
            "countryCode": this.country
          }
          this.viewCompleteRepair = true;
          this.service.getViewDetailsofFDRSAPI(id, this.sessionId).subscribe((data) => {
            this.service.noFaultButtonClick(req1).subscribe((data) => {
              this.viewCompleteRepair = false;
              console.log("No fault Btn Repair:", data);
            })
          })
        } else {
          this.service.selectedGlobalServices.next('PTS Service');
          this.router.navigate(['/globalServiceEnabled']);
        }
      })
    } else {
      // Error Component
      this.router.navigate(['/errorCandidate']);
    }
  }

  getFDRSStatus(networkTestInfo: string, content: string, id: string) {
    localStorage.setItem("component", "fromRepair");
    this.FDRSStatusLoader = true;
    this.service.getFDRSStatusInDiagnostic.next('test');
    if (localStorage.getItem("connectionState") == '1') {
      this.rpcClient.checkFDRSConnectionStatus();
    } else {
      this.fdrsClient.initFdrsClient("");
    }
    this.fdrsSubscription = this.service.getFDRSStatusInDiagnostic.subscribe((data) => {
      if (data == 'true') {
        this.FDRSStatusLoader = false;
        this.service.isNetworkTestNeeded(this.vinNumber,this.UserTypeID,this.countryThree).subscribe((data) => {
          if (data.status) {
            localStorage.setItem("lastVisitedScreen","fromRepair");
            this.modalService.open(networkTestInfo, { centered: true });
          } else {
            const req = {
              "sessionId": this.sessionId,
              "pageid": "13"
            }
            this.service.updatePage(req).subscribe(data => { })
            if (!this.gIdArray.includes(id)) {
              this.gIdArray.push(id);
              this.service.storeGidRepair.next(this.gIdArray);
            }
            localStorage.setItem("lastVisitedScreen", "");
            this.router.navigate(['/otxCandidate']);
          }
        });
      } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && !this.webSocketHandshake) {
        this.rpcClient.checkWebSocketConnectionStatus();
        this.webSocketHandshake = true;
      } else if (data == 'false' && localStorage.getItem("connectionState") == '1' && this.webSocketHandshake) {
        this.FDRSStatusLoader = false;
        this.webSocketHandshake = false;
        this.modalService.open(content, { centered: true });
        this.fdrsSubscription.unsubscribe();
      } else if (data == 'false' && localStorage.getItem("connectionState") !== '1' ) {
        this.FDRSStatusLoader = false;
        this.modalService.open(content, { centered: true });
        this.fdrsSubscription.unsubscribe();
      }
    })
  }

  navigateToNetworkTest() {
    localStorage.setItem("component", "fromNetworkTest");
    this.router.navigate(['/closeCanceldiagnosis']);
  }

  ngOnDestroy() {
    this.fdrsSubscription.unsubscribe();
    this.tokenSubscription.unsubscribe();
    this.serviceNameListSubscription.unsubscribe();
    this.gIdRepairSubscription.unsubscribe();
    this.repairSubscription.unsubscribe();
  }
}
